import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr } from "../../../../Helper/ToastMessage";

export const WTPPumpHouseTableDataAPI = createAsyncThunk("WTPPumpHouseTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_WardID,
        ReadingDate,
        M_ProjectID,
        M_UserID,
        token,
        From,
        To,
        handleGetExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_PumpOperation_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_WardID=${M_WardID}&M_ProjectID=${M_ProjectID}&ReadingDate=${ReadingDate}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data.table) {
                handleGetExport && handleGetExport()
                return result.data.table

            } else {
                return result
            }
        })
})

const WTPPumpHouseTableDataSlice = createSlice({
    name: "WTPPumpHouseTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPumpHouseTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WTPPumpHouseTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WTPPumpHouseTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPPumpHouseTableDataReducer = WTPPumpHouseTableDataSlice.reducer

// Export File

export const WTPPumpHouseExportTableDataAPI = createAsyncThunk("WTPPumpHouseExportTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_WardID,
        ReadingDate,
        M_ProjectID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_WTP_T_WTP_PumpOperation_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_WardID=${M_WardID}&M_ProjectID=${M_ProjectID}&ReadingDate=${ReadingDate}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data.table) {
                return result.data.table

            } else {
                return result
            }
        })
})

const WTPPumpHouseExportTableDataSlice = createSlice({
    name: "WTPPumpHouseExportTableData",
    initialState: {
        isExportLoading: false,
        ExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WTPPumpHouseExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WTPPumpHouseExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExporttableData = action.payload;
        });
        builder.addCase(WTPPumpHouseExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExporttableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WTPPumpHouseExportTableDataReducer = WTPPumpHouseExportTableDataSlice.reducer
